import { AthosFetcher } from '../classes/athos-fetcher'
import { normaliseRecommendations } from '../helpers/normalisers'
import { generateAthosProvider } from './provider'
import { getPersonalizationOrigin } from '../athos-utils'

export class AthosRecommend extends AthosFetcher {
  generateOrigin() {
    return getPersonalizationOrigin(this.params.siteID)
  }

  generateURL() {
    return super.generateURL('/recommend')
  }

  updateParams(options = {}) {
    const { productId, sku, tags, limit, profile } = options
    const product = productId || sku

    if (product) this.params.set('product', product)
    if (tags) this.params.set('tags', tags)
    if (limit) this.params.set('limits', limit)
    if (profile) this.params.set('tags', profile)

    this.params.setViewedProducts()
    this.params.setCartItems()
    this.params.setShopperID()

    super.updateParams()
  }
}

export const AthosRecommendProvider = generateAthosProvider(AthosRecommend, (_results) => {
  const profiles = Array.isArray(_results) ? _results : [_results].filter(Boolean)

  const results = profiles.map((res) => normaliseRecommendations(res)).flat()
  const [firstProfile] = profiles
  return {
    results,
    responseId: firstProfile?.responseId,
    profile: firstProfile?.profile
  }
})
